import crmService from '@/services/crm_service'
import { recursiveAssign } from '@/utils'

const state = {
  quotes: { data: [], included: [] },
  filter: 'new',
  search: ''
}

const mutations = {
  'SET_QUOTES' (state, quotes) {
    state.quotes = quotes
  },
  'SET_QUOTE' (state, { data, included }) {
    // const existing = state.quotes.data.find(obj => obj.id === data.id)
    // if (!existing) state.quotes.data.push(data)
    // else Object.assign(existing, data)
    verify(state, data)
    if (included) included.forEach(obj => verifyIncluded(state, obj))
  },
  'SET_FILTER' (state, value) {
    state.filter = value
  },
  'SET_SEARCH' (state, value) {
    state.search = value
  }
}

const actions = {
  getQuotes ({ commit }, page) {
    crmService.getQuotes(page, quotes => commit('SET_QUOTES', quotes))
  },
  getQuote ({ commit }, id) {
    crmService.getQuote(id, quote => commit('SET_QUOTE', quote))
  },
  setQuoteFilter ({ commit }, value) {
    commit('SET_FILTER', value)
  },
  setQuoteSearch ({ commit }, value) {
    commit('SET_SEARCH', value)
  }
}

const getters = {
  quote: (state) => (id) => {
    return state.quotes.data.find(obj => obj.id === id) || { attributes: {}, relationships: { rows: { data: [] } } }
  }
}

function verify (state, quote) {
  const existing = state.quotes.data.find(a => a.id === quote.id)
  if (!existing) state.quotes.data.push(quote)
  else recursiveAssign(existing, quote)
}

function verifyIncluded (state, obj) {
  const existing = state.quotes.included.find(i => i.id === obj.id && i.type === obj.type)
  if (!existing) state.quotes.included.push(obj)
  else recursiveAssign(existing, obj)
}

export default {
  state,
  actions,
  mutations,
  getters
}
